module.exports = __webpack_public_path__ + "static/media/intro1-2.4cbfa450.png";